import { httpRequest } from '@calendly/http-tools'

import {
  stripeClientSecretError,
  stripeClientSecretFetched,
  stripeClientSecretPending
} from '../../../actions/payment'

export const fetchClientSecret = (eventTypeUuid) => async (dispatch, getState) => {
  const state = getState()
  const { status } = state.scheduling.stripeClientSecret

  // `ready` means no PaymentIntent exists yet; `error` is only re-entered from an explicit retry.
  if (!['ready', 'error'].includes(status) || !eventTypeUuid) return

  dispatch(stripeClientSecretPending())

  const [ok, res] = await httpRequest({
    url: '/api/booking/stripe_payment_intents',
    method: 'POST',
    data: { event_type_uuid: eventTypeUuid }
  })

  if (ok) {
    dispatch(stripeClientSecretFetched(res.resource.client_secret))
  } else {
    dispatch(stripeClientSecretError())
  }
}
